export default "__VITE_ASSET__e6154dd6__"